<template>
    <div class="flex items-center py-3 px-2 my-1">
        <div class="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center mr-3" />
        <div class="flex flex-col">
            <div class="flex items-center space-x-2">
                <div class="w-36 h-5 bg-gray-300 rounded-md" />
                <div class="w-27 h-5 bg-gray-200 rounded-md" />
            </div>
            <div class="text-sm text-gray-500 flex space-x-1 mt-1">
                <span class="w-28 h-5 bg-gray-200 rounded-md" />
                <span class="w-28 h-5 bg-gray-200 rounded-md" />
            </div>
        </div>
    </div>
</template>

<script></script>
